import {
	SET_MODULES,
	SET_DATA_SOURCES,
	SET_DATA_SOURCE_FIELDS,
	SET_DATA_SOURCE_FILTERS,
	RESET_STATE,
	SET_REPORT_DETAIL,
	SET_CUSTOM_REPORTS,
	REMOVE_CUSTOM_REPORTS,
	SET_CURRENT_STEP,
	SET_LAST_STEP_VISITED,
	ADD_DATA_SOURCE,
	REMOVE_DATA_SOURCE,
	SET_COMPANIES,
	SET_REPORT_FILTERSETS,
	SET_REPORT_EDITING_FILTERSETS,
	UPDATE_FILTERSET_FILTERS,
	SET_REMOVE_DUPLICATES,
	SET_REPORT_NAME,
	SET_REPORT_FAVORITE,
	UPDATE_FILTERSET_CONJUNCTION,
	SET_REPORT_COLUMNS,
	UPDATE_COLUMN_FIELD,
	ADD_FILTERSET,
	REMOVE_FILTERSET,
	COPY_REPORT_FILTERS,
	SAVE_REPORT,
	SET_REPORT_VISIBLE,
	SET_REPORT_HISTORY,
	SET_REPORT_DATA_SOURCES,
	ADD_FILTER_DETAIL,
	SET_REPORT_ACCESS,
	SET_REPORT_ACCESS_ENTITY,
	UPDATE_REPORT_ACCESS,
	SAVE_REPORT_DETAIL,
	UPDATE_FILTERSETS,
	UPDATE_EDITING_FILTERSETS,
	UPDATE_FILTERSETS_ORDER,
	UPDATE_FILTERSET_FILTERS_ORDER,
	SET_SEARCH_LIST_RESULTS,
	SET_DOWNLOADED_EXPORT_FILE,
	UPDATE_REPORT_ACCESS_PUBLIC,
	SET_REPORT_STATUS,
	SET_REPORT_DATA_SOURCE_ITEMS,
	SET_DOWNLOADED_PRINT_FILE,
	SET_EDIT_REPORT_ID,
	SET_REPORT_ID,
	REMOVE_REPORT_HISTORY,
	SET_OFFLINE_REPORT_REQUEST,
	CLEAR_OFFLINE_REPORT,
	UPDATE_SCHEDULED_TASKS_COUNT,
	SET_HAS_SCHEDULED_TASKS,
	SET_BULKEDIT_UPDATE_DATASOURCE_FIELDS
} from './reports-mutation-types';
import api from '@/services/api-service';
import accessWebApi from '@/services/accessweb-api-service';
import buildRoute from '@/composables/build-route';
import Vue from 'vue';
import gatherItems from '@/utils/gather-items';
import { cloneDeep, clone } from 'lodash';
import { Read, UpdateAndDelete } from '@/constants/access-rights';
import { isUndefinedOrNullOrEmpty } from '@/utils/inspect';

const initialState = {
	modules: undefined,
	dataSources: undefined,
	dataSourceFields: {},
	dataSourceFilters: {},
	reportDetail: {
		id: 0,
		reportName: undefined
	},
	customReportsResults: {},
	currentStep: 1,
	lastStepVisited: 1,
	dataSourceIds: [],
	companies: [],
	reportFiltersets: {},
	reportEditingFiltersets: {},
	reportColumns: {},
	visible: true,
	reportHistory: {},
	reportAccess: {},
	reportAccessEntity: {},
	filterDetails: {},
	searchListResults: {},
	exportFileUrlResult: {},
	printFileUrlResult: {},
	reportDataSources: {},
	editReportId: null,
	offlineReportRequest: undefined,
	bulkEditUpdateSourceFields: {}
};

const isEqualQuery = (query1, query2, ignorePaging) => {
	const isCompanyIdEqual = (id1, id2) => {
		if (Array.isArray(id1) && Array.isArray(id2)) {
			if (id1.length !== id2.length) {
				return false;
			}
			return [...id1].sort().toString() === [...id2].sort().toString();
		}
		if (Array.isArray(id1)) {
			return id1.includes(id2);
		}
		if (Array.isArray(id2)) {
			return id2.includes(id1);
		}
		return id1 === id2;
	};

	let result = false;

	result =
		isCompanyIdEqual(query1.companyId, query2.companyId) &&
		(query1.searchString === query2.searchString ||
			(isUndefinedOrNullOrEmpty(query1.searchString) &&
				isUndefinedOrNullOrEmpty(query2.searchString))) &&
		query1.fieldId === query2.fieldId &&
		(ignorePaging ||
			(query1.page === query2.page &&
				query1.maxCount === query2.maxCount));

	return result;
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'reports',
	namespaced: true,
	state: cloneDeep(initialState),
	mutations: {
		[RESET_STATE](state) {
			for (const key in state) {
				Vue.set(state, key, clone(initialState[key]));
			}
		},
		[SET_MODULES](state, modulesResults) {
			state.modules = modulesResults;
		},
		[SET_DATA_SOURCES](state, dataSourcesResults) {
			state.dataSources = dataSourcesResults;
		},
		[SET_DATA_SOURCE_FIELDS](state, dataSourceFieldsResults) {
			state.dataSourceFields = dataSourceFieldsResults;
		},
		[SET_DATA_SOURCE_FILTERS](state, dataSourceFilters) {
			state.dataSourceFilters = dataSourceFilters;
		},
		[SET_REPORT_DETAIL](state, reportDetail) {
			state.reportDetail = reportDetail;
		},
		[SET_CUSTOM_REPORTS](state, customReportsResults) {
			Vue.set(
				state.customReportsResults,
				customReportsResults.page + '',
				customReportsResults
			);
		},
		[REMOVE_CUSTOM_REPORTS](state) {
			state.customReportsResults = {};
		},
		[SET_MODULES](state, modulesResults) {
			state.modules = modulesResults;
		},
		[SET_DATA_SOURCES](state, dataSourcesResults) {
			state.dataSources = dataSourcesResults;
		},
		[SET_CURRENT_STEP](state, stepNumber) {
			state.currentStep = stepNumber;
		},
		[SET_LAST_STEP_VISITED](state, stepNumber) {
			state.lastStepVisited = stepNumber;
		},
		[SET_REPORT_DATA_SOURCES](state, dataSourceIds) {
			state.dataSourceIds = [];
			dataSourceIds.forEach(dataSourceId => {
				if (dataSourceId > 0)
					state.dataSourceIds.splice(
						state.dataSourceIds.length,
						0,
						dataSourceId
					);
			});
		},
		[ADD_DATA_SOURCE](state, dataSourceId) {
			const index = state.dataSourceIds.indexOf(dataSourceId);

			if (index < 0) {
				state.dataSourceIds.splice(
					state.dataSourceIds.length,
					0,
					dataSourceId
				);
			}
		},
		[REMOVE_DATA_SOURCE](state, dataSourceId) {
			const index = state.dataSourceIds.indexOf(dataSourceId);

			if (index >= 0) {
				state.dataSourceIds.splice(index, 1);
			}
		},
		[SET_COMPANIES](state, companies) {
			state.companies = companies;
		},
		[SET_REPORT_FILTERSETS](state, filtersets) {
			state.reportFiltersets = filtersets;
		},
		[SET_REPORT_EDITING_FILTERSETS](state, filtersets) {
			state.reportEditingFiltersets = filtersets;
		},
		[UPDATE_FILTERSET_FILTERS](state, { index, filters }) {
			const filterset = state.reportFiltersets.items[index];

			if (filterset) {
				Vue.set(filterset, 'items', [...filters]);
			}
		},
		[UPDATE_FILTERSET_FILTERS_ORDER](state, { index, filters }) {
			const filterset = state.reportFiltersets.items[index];

			if (filterset) {
				filters.forEach(
					(element, index) => (element.filterOrder = index)
				);

				Vue.set(filterset, 'items', [...filters]);
			}
		},
		[SET_REMOVE_DUPLICATES](state, removeDuplicates) {
			Vue.set(state.reportDetail, 'removeDuplicates', removeDuplicates);
		},
		[SET_REPORT_NAME](state, reportName) {
			Vue.set(state.reportDetail, 'reportName', reportName);
		},
		[SET_REPORT_ID](state, reportId) {
			Vue.set(state.reportDetail, 'id', reportId);
		},
		[SET_REPORT_FAVORITE](state, { reportId, isFavorite }) {
			if (state.reportDetail && state.reportDetail.id === reportId) {
				Vue.set(state.reportDetail, 'favorite', isFavorite);
			}
			const items = gatherItems(state.customReportsResults);
			if (items) {
				const reportRecord = items.find(r => r.id === reportId);

				if (reportRecord) {
					Vue.set(reportRecord, 'favorite', isFavorite);
				}
			}
		},
		[UPDATE_FILTERSET_CONJUNCTION](state, { index, value }) {
			const fs = state.reportFiltersets.items[index];

			if (fs) {
				Vue.set(fs, 'groupConjunction', value);
			}
		},
		[UPDATE_COLUMN_FIELD](state, { id, fieldName, fieldValue }) {
			const cl = state.reportColumns.items.filter(c => {
				return c.reportGeneratorFieldId === id;
			})[0];

			if (cl) {
				Vue.set(cl, fieldName, fieldValue);
			}
		},
		[SET_REPORT_COLUMNS](state, columns) {
			Vue.set(state, 'reportColumns', columns);
		},
		[ADD_FILTERSET](state, filterset) {
			state.reportFiltersets.items.splice(
				state.reportFiltersets.items.length,
				0,
				filterset
			);
		},
		[UPDATE_FILTERSETS](state, filtersets) {
			Vue.set(state.reportFiltersets, 'items', [...filtersets]);
		},
		[UPDATE_EDITING_FILTERSETS](state, filtersets) {
			Vue.set(state.reportEditingFiltersets, 'items', [...filtersets]);
		},
		[UPDATE_FILTERSETS_ORDER](state, filtersets) {
			if (filtersets) {
				filtersets.forEach(
					(element, index) => (element.filterGroupOrder = index)
				);
				Vue.set(state.reportFiltersets, 'items', [...filtersets]);
			}
		},
		[REMOVE_FILTERSET](state, index) {
			state.reportFiltersets.items.splice(index, 1);
		},
		[COPY_REPORT_FILTERS](state, filtersets) {
			if (filtersets.items != null) {
				filtersets.items.forEach(function(object) {
					object.id = 0;
					if (object.items != null) {
						object.items.forEach(function(obj) {
							obj.id = 0;
						});
					}
				});
			}

			state.reportFiltersets = filtersets;
		},
		[SET_REPORT_HISTORY](state, reportHistory) {
			Vue.set(
				state.reportHistory,
				reportHistory.page + '',
				reportHistory
			);
		},
		[REMOVE_REPORT_HISTORY](state) {
			state.reportHistory = {};
		},
		[ADD_FILTER_DETAIL](state, filter) {
			const id = filter?.id;

			Vue.set(state.filterDetails, id, filter);
		},
		[SET_REPORT_ACCESS](state, reportAccess) {
			state.reportAccess = reportAccess;
		},
		[SET_REPORT_ACCESS_ENTITY](state, reportAccessEntity) {
			state.reportAccessEntity = reportAccessEntity;
		},
		[UPDATE_REPORT_ACCESS](state, accessList) {
			Vue.set(state.reportAccess, 'items', accessList);
		},
		[UPDATE_REPORT_ACCESS_PUBLIC](state, publicReport) {
			Vue.set(state.reportAccess, 'publicReport', publicReport);
		},
		[SET_REPORT_VISIBLE](state, visible) {
			Vue.set(state.reportDetail, 'visible', visible);
		},
		[SAVE_REPORT_DETAIL](state, reportDetail) {
			state.reportDetail = reportDetail;
		},
		[SAVE_REPORT](state, report) {
			state.reportColumns = report.columns;
			state.reportFiltersets = report.filters;
			state.reportEditingFiltersets = report.filters;
			state.reportAccess = report.access;
			state.companies = report.companies;
			state.dataSource = report.dataSource;
			state.reportDetail = report;
		},
		[SET_SEARCH_LIST_RESULTS](state, { query, searchResults }) {
			//store this in state so we don't need to re-do dupe queries
			let searchResultItemMatch;
			const searchResultItem = {
				query: query,
				searchResults: searchResults
			};
			if (!state.searchListResults[query.fieldId]) {
				//no stored results for this field
				Vue.set(state.searchListResults, query.fieldId, [
					searchResultItem
				]);
			}

			searchResultItemMatch = state.searchListResults[
				query.fieldId
			].find(q => isEqualQuery(searchResultItem.query, q.query));

			if (!searchResultItemMatch) {
				const previousPageQuery = { ...query, page: query.page - 1 };

				const previousPageResults = state.searchListResults[
					query.fieldId
				].find(sr => isEqualQuery(previousPageQuery, sr.query));

				if (previousPageResults) {
					searchResultItem.searchResults.items = [
						...previousPageResults.searchResults.items,
						...searchResultItem.searchResults.items
					];
				}

				state.searchListResults[query.fieldId].splice(
					state.searchListResults[query.fieldId].length,
					0,
					searchResultItem
				);
			}
		},
		[SET_REPORT_STATUS](state, active) {
			Vue.set(state.reportDetail, 'active', active);
		},
		[SET_REPORT_DATA_SOURCE_ITEMS](state, reportDataSources) {
			state.reportDataSources = reportDataSources;
		},
		[SET_DOWNLOADED_EXPORT_FILE](state, exportFileUrlResult) {
			state.exportFileUrlResult = exportFileUrlResult;
		},
		[SET_DOWNLOADED_PRINT_FILE](state, printFileUrlResult) {
			state.printFileUrlResult = printFileUrlResult;
		},
		[SET_EDIT_REPORT_ID](state, editReportId) {
			state.editReportId = editReportId;
		},
		[SET_OFFLINE_REPORT_REQUEST](state, offlineReportRequest) {
			if (
				state.reportDetail &&
				state.reportDetail.id == offlineReportRequest.ReportId
			) {
				state.offlineReportRequest = offlineReportRequest;
			}
		},
		[CLEAR_OFFLINE_REPORT](state) {
			state.offlineReportRequest = undefined;
		},
		[UPDATE_SCHEDULED_TASKS_COUNT](state, { reportId, newScheduleCount }) {
			const items = gatherItems(state.customReportsResults);
			const report = items.find(r => r.id === reportId);

			newScheduleCount = newScheduleCount || 0;
			if (report) {
				report.scheduledTasksCount = newScheduleCount;
			}
		},
		[SET_HAS_SCHEDULED_TASKS](state, hasScheduledTasks) {
			Vue.set(state.reportDetail, 'hasScheduledTasks', hasScheduledTasks);
		},
		[SET_BULKEDIT_UPDATE_DATASOURCE_FIELDS](
			state,
			bulkEditUpdateSourceFieldsResults
		) {
			Vue.set(
				state,
				'bulkEditUpdateSourceFields',
				bulkEditUpdateSourceFieldsResults
			);
		}
	},
	actions: {
		clearOfflineReportAction({ commit }) {
			commit(CLEAR_OFFLINE_REPORT);
		},
		setOfflineReportRequestAction({ commit }, offlineReportRequest) {
			commit(SET_OFFLINE_REPORT_REQUEST, offlineReportRequest);
		},
		// actions let us get to ({ state, getters, commit, dispatch })
		async createExportFileAction(
			{ commit },
			{ dealerGuid, dealerNumber, companyId, reportId, format, reportKey }
		) {
			const fileUrlResults = await accessWebApi.get(
				buildRoute(
					'/integration/{dealerguid}/{dealerNumber}/{companyId}/createreportgeneratorfile/{reportId}/{format}',
					{
						dealerguid: dealerGuid,
						dealerNumber: dealerNumber,
						companyId: companyId,
						reportId: reportId,
						format: format,
						query: {
							reportKey: reportKey
						}
					}
				)
			);

			commit(SET_DOWNLOADED_EXPORT_FILE, fileUrlResults);
		},
		async createPrintFileAction(
			{ commit },
			{ dealerGuid, dealerNumber, companyId, reportId, format, reportKey }
		) {
			const fileUrlResults = await accessWebApi.get(
				buildRoute(
					'/integration/{dealerguid}/{dealerNumber}/{companyId}/createreportgeneratorfile/{reportId}/{format}',
					{
						dealerguid: dealerGuid,
						dealerNumber: dealerNumber,
						companyId: companyId,
						reportId: reportId,
						format: format,
						query: {
							reportKey: reportKey
						}
					}
				)
			);

			commit(SET_DOWNLOADED_PRINT_FILE, fileUrlResults);
		},
		async getSearchListAction(
			{ commit, getters },
			{ companyId, searchString, fieldId, page, maxCount }
		) {
			const query = {
				companyId: companyId,
				searchString: searchString,
				fieldId: fieldId,
				page: page,
				maxCount: maxCount
			};

			let searchResults = getters.searchListResult(query)?.searchResults;

			if (!searchResults) {
				searchResults = await api.get(
					buildRoute(
						'/reportgenerator/customreports/filtervaluelist',
						{
							query
						}
					)
				);

				commit(SET_SEARCH_LIST_RESULTS, { query, searchResults });
			}
		},
		setCurrentStepAction({ commit }, stepNumber) {
			commit(SET_CURRENT_STEP, stepNumber);
		},
		setLastStepVisitedAction({ commit }, stepNumber) {
			commit(SET_LAST_STEP_VISITED, stepNumber);
		},
		setReportDataSourcesAction({ commit }, dataSourceIds) {
			if (!Array.isArray(dataSourceIds)) {
				dataSourceIds = [dataSourceIds];
			}
			commit(SET_REPORT_DATA_SOURCES, dataSourceIds);
		},
		addDataSourceAction({ commit }, dataSourceId) {
			commit(ADD_DATA_SOURCE, dataSourceId);
		},
		removeDataSourceAction({ commit }, dataSourceId) {
			commit(REMOVE_DATA_SOURCE, dataSourceId);
		},
		setCompaniesAction({ commit }, companies) {
			commit(SET_COMPANIES, companies);
		},
		setReportFiltersetsAction({ commit }, filtersets) {
			commit(SET_REPORT_FILTERSETS, filtersets);
		},
		setReportEditingFiltersetsAction({ commit }, filtersets) {
			commit(SET_REPORT_EDITING_FILTERSETS, filtersets);
		},
		updateFiltersetFiltersAction({ commit }, { index, filters }) {
			commit(UPDATE_FILTERSET_FILTERS, { index, filters });
		},
		updateFiltersetFiltersOrderAction({ commit }, { index, filters }) {
			commit(UPDATE_FILTERSET_FILTERS_ORDER, { index, filters });
		},
		updateRemoveDuplicatesAction({ commit }, removeDuplicates) {
			commit(SET_REMOVE_DUPLICATES, removeDuplicates);
		},
		setReportNameAction({ commit }, reportName) {
			commit(SET_REPORT_NAME, reportName);
		},
		setReportFavoriteAction({ commit }, favorite) {
			commit(SET_REPORT_FAVORITE, favorite);
		},
		updateFiltersetConjunctionAction({ commit }, { index, value }) {
			commit(UPDATE_FILTERSET_CONJUNCTION, { index, value });
		},
		updateFiltersetsAction({ commit }, filtersets) {
			commit(UPDATE_FILTERSETS, filtersets);
		},
		updateEditingFiltersetsAction({ commit }, filtersets) {
			commit(UPDATE_EDITING_FILTERSETS, filtersets);
		},
		updateFiltersetsOrderAction({ commit }, filtersets) {
			commit(UPDATE_FILTERSETS_ORDER, filtersets);
		},
		setReportColumnsAction({ commit }, columns) {
			commit(SET_REPORT_COLUMNS, columns);
		},
		updateColumnFieldAction({ commit }, { id, fieldName, fieldValue }) {
			commit(UPDATE_COLUMN_FIELD, { id, fieldName, fieldValue });
		},
		addFiltersetAction({ commit }, filterset) {
			commit(ADD_FILTERSET, filterset);
		},
		removeFiltersetAction({ commit }, index) {
			commit(REMOVE_FILTERSET, index);
		},
		async saveReportNameAction(
			{ commit, state },
			{ reportName, errorHandler }
		) {
			const report = await api.post(
				buildRoute('/reportgenerator/customreports/{id}/name', {
					id: state.reportDetail.id
				}),
				{
					id: state.reportDetail.id,
					favorite: state.reportDetail.favorite,
					reportName: reportName,
					reportUrl: state.reportDetail.reportUrl,
					active: state.reportDetail.active
				},
				errorHandler
			);

			if (report) {
				commit(SAVE_REPORT_DETAIL, report);
			}
		},
		async saveReportFavoriteAction({ commit }, { reportId, isFavorite }) {
			const method = isFavorite ? 'delete' : 'post';

			await api[method](
				buildRoute('/reportgenerator/customreports/{id}/favorite', {
					id: reportId
				})
			);

			commit(SET_REPORT_FAVORITE, { reportId, isFavorite: !isFavorite });
		},
		async saveReportStatusAction({ commit, state }, status) {
			await api.post(
				buildRoute('/reportgenerator/customreports/{id}/status', {
					id: state.reportDetail.id
				}),
				{
					id: state.reportDetail.id,
					active: status
				}
			);

			commit(SET_REPORT_STATUS, status);
		},
		async saveReportAction(
			{ commit, state, dispatch },
			{ editReportId, errorHandler, reportName, visible }
		) {
			const reportPayload = { ...state.reportDetail };
			const reportId = reportPayload.id || editReportId || 0;
			let report;
			let secondaryDataSourceIds;

			reportPayload.reportName = reportName;
			reportPayload.visible = visible || false;

			reportPayload.filters = { ...state.reportFiltersets };
			reportPayload.filters.reportId = reportId;

			reportPayload.columns = { ...state.reportColumns };
			reportPayload.columns.reportId = reportId;

			reportPayload.access = { ...state.reportAccess };
			reportPayload.access.reportId = reportId;

			reportPayload.active = true;
			reportPayload.access.items = reportPayload.access?.items || [];
			reportPayload.publicReport =
				reportPayload.access?.publicReport || false;

			reportPayload.dataSource = {
				id: state.dataSourceIds[0],
				reportId: reportId
			};

			if (state.dataSourceIds.length > 1) {
				if (!state.dataSources?.items?.length) {
					await dispatch('getDataSourcesAction', state.companies);
				}
				secondaryDataSourceIds = [...state.dataSourceIds.slice(1)];
				const dataSources = state.dataSources.items.find(
					ds => ds.id === state.dataSourceIds[0]
				);
				reportPayload.dataSource.items = dataSources.items
					.filter(s => secondaryDataSourceIds.includes(s.id))
					.map(x => {
						return { id: x.reportGeneratorSecondaryDatasetId };
					});
			}

			if (state.companies) {
				reportPayload.companies = Array.isArray(state.companies)
					? {
							reportId: reportId,
							items: state.companies.map(cid => {
								return { companyId: cid, reportId: reportId };
							})
					  }
					: state.companies;
			}
			report = await api.post(
				buildRoute('/reportgenerator/customreports/{id}', {
					id: reportId || 0
				}),
				reportPayload,
				errorHandler
			);

			if (report) {
				commit(SAVE_REPORT, report);
			}
		},
		async copyReportAction(
			{ commit, dispatch, state },
			{ copyReportName, errorHandler }
		) {
			const previousState = state.reportDetail;
			let reportId = 0;
			let details = { ...state.reportDetail };
			details.id = reportId;
			details.reportName = copyReportName;

			commit(SAVE_REPORT_DETAIL, details);

			let filters = { ...state.reportFiltersets };
			filters.reportId = reportId;
			filters.reportName = copyReportName;

			commit(COPY_REPORT_FILTERS, filters);

			await dispatch('saveReportAction', {
				editReportId: reportId,
				errorHandler,
				reportName: copyReportName,
				visible: true
			});

			//update did not succeed
			if (state.reportDetail.id === 0) {
				commit(SAVE_REPORT_DETAIL, previousState);
			}

			reportId = state.reportDetail.id;
			return reportId;
		},
		async saveReportAccessAction({ commit, state }) {
			const access = await api.post(
				buildRoute('/reportgenerator/customreports/{id}/access', {
					id: state.reportAccess.reportId
				}),
				state.reportAccess
			);
			commit(SET_REPORT_ACCESS, access);
		},
		async saveReportFiltersAction({ commit, state }) {
			const filters = await api.post(
				buildRoute('/report/{id}/filters', {
					id: state.reportFiltersets.reportId
				}),
				state.reportFiltersets
			);
			commit(SET_REPORT_FILTERSETS, filters);
		},
		async saveReportColumnsAction({ commit, state }) {
			const columns = await api.post(
				buildRoute('/report/{id}/columns', {
					id: state.reportColumns.reportId
				}),
				state.reportColumns
			);
			commit(SET_REPORT_ACCESS, columns);
		},
		setReportVisibleAction({ commit }, visible) {
			commit(SET_REPORT_VISIBLE, visible);
		},
		async getCustomReportsAction({ commit }, searchParameters) {
			const customReportsResults = await api.get(
				buildRoute('/reportgenerator/customreports', {
					query: searchParameters
				})
			);
			commit(SET_CUSTOM_REPORTS, customReportsResults);
		},
		resetCustomReportsAction({ commit }) {
			commit(REMOVE_CUSTOM_REPORTS);
		},
		resetSharedStateAction({ commit }) {
			commit(RESET_STATE);
		},
		async getModulesAction({ commit }, companyIds) {
			const modulesResults = await api.get(
				buildRoute('/reportgenerator/modules', {
					companyId: companyIds
				})
			);
			commit(SET_MODULES, modulesResults);
		},
		async getDataSourcesAction({ commit }, companyIds) {
			const dataSourcesResults = await api.get(
				buildRoute('/reportgenerator/datasources', {
					query: {
						companyId: companyIds
					}
				})
			);
			commit(SET_DATA_SOURCES, dataSourcesResults);
		},
		async getDataSourceFieldsAction(
			{ commit },
			{ dataSourceIds, bulkEditQuery, bulkEditUpdate }
		) {
			const dataSourceFieldsResults = await api.get(
				buildRoute('/reportgenerator/datasources/fields', {
					query: {
						dataSourceIds: dataSourceIds,
						bulkEditQuery: bulkEditQuery,
						bulkEditUpdate: bulkEditUpdate
					}
				})
			);
			if (bulkEditUpdate) {
				commit(
					SET_BULKEDIT_UPDATE_DATASOURCE_FIELDS,
					dataSourceFieldsResults
				);
			} else {
				commit(SET_DATA_SOURCE_FIELDS, dataSourceFieldsResults);
			}
		},
		async getDataSourceDefaultFiltersAction(
			{ commit },
			{ dataSourceIds, bulkEditQuery, bulkEditUpdate }
		) {
			const reportFiltersResults = await api.get(
				buildRoute('/reportgenerator/datasources/filters', {
					query: {
						dataSourceIds: dataSourceIds,
						bulkEditQuery: bulkEditQuery,
						bulkEditUpdate: bulkEditUpdate
					}
				})
			);

			commit(SET_DATA_SOURCE_FILTERS, reportFiltersResults);
		},
		async getReportDetailAction({ commit }, { id, customErrorHandler }) {
			const reportDetail = await api.get(
				buildRoute('/reportgenerator/customreports/{id}/detail', {
					id: id
				}),
				customErrorHandler
			);
			commit(SET_REPORT_DETAIL, reportDetail);
		},
		async getReportHistoryAction(
			{ commit },
			{
				reportId,
				changedByUserIds,
				minDatetime,
				maxDatetime,
				maxCount,
				page,
				sortDirection
			}
		) {
			let reportHistory;
			let query = {
				reportId: reportId,
				minDatetime: minDatetime,
				maxDatetime: maxDatetime,
				maxCount: maxCount,
				page: page,
				sortDirection: sortDirection
			};

			if (changedByUserIds?.length) {
				query.changedByUserIds = changedByUserIds;
			}

			reportHistory = await api.get(
				buildRoute('/logs/customreporthistory', {
					query
				})
			);

			commit(SET_REPORT_HISTORY, reportHistory);
		},
		resetReportHistoryAction({ commit }) {
			commit(REMOVE_REPORT_HISTORY);
		},
		async getFilterByIdAction({ commit }, filterId) {
			const filter = await api.get(
				buildRoute('/reportgenerator/datasources/filters/{id}', {
					id: filterId
				})
			);

			commit(ADD_FILTER_DETAIL, filter);
		},
		async getReportAccessAction({ commit }, reportId) {
			const reportAccess = await api.get(
				buildRoute('/reportgenerator/customreports/{id}/access', {
					id: reportId
				})
			);

			commit(SET_REPORT_ACCESS, reportAccess);
		},
		async getReportAccessByEntityAction(
			{ commit },
			{ reportId, entityId, entityType }
		) {
			const reportAccessEntity = await api.get(
				buildRoute(
					'/reportgenerator/customreports/{id}/access/{entityId}/{entityType}',
					{
						id: reportId,
						entityId: entityId,
						entityType: entityType
					}
				)
			);
			commit(SET_REPORT_ACCESS_ENTITY, reportAccessEntity);
		},
		async getReportColumnsAction({ commit }, reportId) {
			const reportColumns = await api.get(
				buildRoute('/reportgenerator/customreports/{id}/columns', {
					id: reportId
				})
			);

			commit(SET_REPORT_COLUMNS, reportColumns);
		},
		async getReportFiltersAction({ commit }, reportId) {
			const reportFiltersets = await api.get(
				buildRoute('/reportgenerator/customreports/{id}/filters', {
					id: reportId
				})
			);

			commit(SET_REPORT_FILTERSETS, reportFiltersets);
		},
		updateReportAccessAction({ commit }, accessList) {
			commit(UPDATE_REPORT_ACCESS, accessList);
		},
		updateReportAccessPublicAction({ commit }, publicReport) {
			commit(UPDATE_REPORT_ACCESS_PUBLIC, publicReport);
		},
		async getReportFullAction({ commit }, reportId) {
			const reportFull = await api.get(
				buildRoute('/reportgenerator/customreports/{id}', {
					id: reportId
				})
			);

			commit(SET_REPORT_ID, reportFull.id);
			commit(SET_REPORT_NAME, reportFull.reportName);
			commit(SET_REPORT_STATUS, reportFull.active);
			commit(UPDATE_REPORT_ACCESS_PUBLIC, reportFull.publicReport);
			commit(SET_REPORT_VISIBLE, reportFull.visible);
			if (reportFull.visible) commit(SET_EDIT_REPORT_ID, reportId);
			commit(SET_REPORT_FILTERSETS, reportFull.filters);
			commit(SET_REPORT_COLUMNS, reportFull.columns);
			commit(SET_REPORT_ACCESS, reportFull.access);

			const companyIds = reportFull.companies.items.map(x => x.companyId);
			commit(SET_COMPANIES, companyIds);

			let dataSourceIds = [reportFull.dataSource.id];
			dataSourceIds.push(...reportFull.dataSource.items.map(x => x.id));

			commit(SET_REPORT_DATA_SOURCES, dataSourceIds);
			commit(SET_REPORT_DATA_SOURCE_ITEMS, reportFull.dataSource);
			commit(SET_HAS_SCHEDULED_TASKS, reportFull.hasScheduledTasks);
		},
		setReportDataSourceItemsAction(
			{ commit, state },
			{ dataSourceId, reportId }
		) {
			let dataSource = state.dataSources.items.find(
				source => source.id === dataSourceId
			);

			if (dataSource) {
				commit(SET_REPORT_DATA_SOURCE_ITEMS, {
					...dataSource,
					reportId
				});
			}
		},
		async saveReportStatusByIdAction(_, { id, status }) {
			await api.post(
				buildRoute('/reportgenerator/customreports/{id}/status', {
					id: id
				}),
				{
					id: id,
					active: status
				}
			);
		},
		async saveBulkEditQueryAction(
			{ commit, state },
			{ reportId, bulkEditId }
		) {
			const customReportId = reportId || 0;
			const reportPayload = {
				id: bulkEditId || 0,
				customReportId: customReportId,
				reportName: state.reportDetail.reportName,
				filters: { ...state.reportFiltersets },
				dataSource: state.reportDataSources
			};

			const report = await api.post(
				buildRoute('/reportgenerator/bulkedit/query'),
				reportPayload
			);

			if (report) {
				commit(SAVE_REPORT, report);
			}
		},
		updateScheduledTasksCountAction(
			{ commit },
			{ reportId, newScheduleCount }
		) {
			commit(UPDATE_SCHEDULED_TASKS_COUNT, {
				reportId,
				newScheduleCount
			});
		}
	},
	getters: {
		offlineReportRequest: state => state.offlineReportRequest,
		offlineReportKey: state => {
			if (state.offlineReportRequest) {
				return state.offlineReportRequest.ReportKey;
			}
		},
		editReportId: state => state.editReportId,
		exportFileUrlResult: state => state.exportFileUrlResult,
		printFileUrlResult: state => state.printFileUrlResult,
		modules: state => state.modules,
		dataSources: state => state.dataSources,
		dataSourceFields: state => dataSourceIds => {
			let dataSourceFields = [];
			let ids = dataSourceIds;

			if (!Array.isArray(ids)) {
				ids = [ids];
			}

			ids = ids.map(i => parseInt(i));

			if (state.dataSourceFields && state.dataSourceFields.items) {
				dataSourceFields = state.dataSourceFields.items.filter(item => {
					return ids.indexOf(item.dataSourceId) >= 0;
				});
			}

			return dataSourceFields;
		},
		dataSourceFilters: state => dataSourceIds => {
			let dataSourceFilters = [];
			let ids = dataSourceIds;

			if (!Array.isArray(ids)) {
				ids = [ids];
			}

			ids = ids.map(i => parseInt(i));

			if (state.dataSourceFilters && state.dataSourceFilters.items) {
				dataSourceFilters = state.dataSourceFilters.items.filter(
					item => {
						return ids.indexOf(item.dataSourceId) >= 0;
					}
				);
			}

			return dataSourceFilters;
		},
		reportDetail: state => state.reportDetail,
		reportColumns: state => state.reportColumns,
		reportFilters: state => state.reportFilters,
		reportAccess: state => state.reportAccess,
		reportName: state =>
			state.reportDetail && state.reportDetail.reportName,
		favorite: state => state.reportDetail && state.reportDetail.favorite,
		active: state => state.reportDetail && state.reportDetail.active,
		//customReportsResults: state => state.customReportsResults,
		customReportsResultsItems: state => {
			const items = gatherItems(state.customReportsResults);
			return items;
		},
		customReportsCount: state => {
			let count = 1;

			if (state.customReportsResults && state.customReportsResults[1]) {
				count = state.customReportsResults[1].totalCount;
			}

			return count;
		},
		customReportsPageCount: state => {
			let count = 1;

			if (state.customReportsResults && state.customReportsResults[1]) {
				count = state.customReportsResults[1].totalPageCount;
			}

			return count;
		},
		currentStep: state => state.currentStep,
		lastStepVisited: state => state.lastStepVisited,
		reportCompanyIds: state => {
			return state.companies;
		},
		reportFiltersets: state => state.reportFiltersets,
		reportEditingFiltersets: state => state.reportEditingFiltersets,
		removeDuplicates: state =>
			state.reportDetail && state.reportDetail.removeDuplicates,
		reportHistory: state => state.reportHistory,
		reportHistoryItems: state => {
			const items = gatherItems(state.reportHistory);
			return items;
		},
		reportHistoryTotalCount: state => {
			let count = 1;

			if (state.reportHistory && state.reportHistory[1]) {
				count = state.reportHistory[1].totalCount;
			}

			return count;
		},
		dataSourceIds: state => state.dataSourceIds,
		filterDetail: state => filterId => {
			return state.filterDetails[filterId];
		},
		searchListResult: state => ({
			companyId,
			searchString,
			fieldId,
			page,
			maxCount
		}) => {
			let result;

			if (state.searchListResults[fieldId]) {
				result = state.searchListResults[fieldId].find(sr =>
					isEqualQuery(
						{
							companyId,
							searchString,
							fieldId,
							page,
							maxCount
						},
						sr.query
					)
				);
			}

			return result;
		},
		fileReportUrl: state => state.fileUrlResults.data.reportURL,
		searchListResultAll: (state, getters) => ({
			companyId,
			searchString,
			fieldId,
			page
		}) => {
			let result;

			if (state.searchListResults[fieldId]) {
				const results = state.searchListResults[fieldId];
				const query = {
					companyId: companyId,
					searchString: searchString,
					fieldId: fieldId,
					page: page,
					maxCount: results[0].searchResults.countPerPage
				};

				result = getters.searchListResult(query)?.searchResults;
			}
			return result;
		},
		reportDataSources: state => state.reportDataSources,
		reportDataSourcePermissions: state => {
			let permissions = [state.reportDataSources.menuFeatureId];
			if (
				state.reportDataSources &&
				state.reportDataSources.items &&
				state.reportDataSources.items.length > 0
			) {
				permissions.push(
					...state.reportDataSources.items.map(x => x.menuFeatureId)
				);
			}

			return permissions;
		},
		reportAccessLevel: state => userId => {
			let accessLevel = Read;
			if (state.reportAccessEntity)
				if (userId === state.reportAccessEntity.ownerEmployeeId)
					accessLevel = UpdateAndDelete;
				else
					accessLevel =
						state.reportAccessEntity.accessLevel || accessLevel;

			return accessLevel;
		},
		bulkEditUpdateSourceFields: state =>
			state.bulkEditUpdateSourceFields?.items || []
	}
};
